<template>
  <div class="home-filter">
    <section class="clearfix">
          <div class="select-div fl ">
            <div class="select-box fl van-hairline--surround" @click="onFilterStation">
              <p>{{checkTipPosition}}<img class="filter-arrow" src="../../assets/images/post/bottom_arrow.png" /></p>
            </div>
            <div class="select-box fl van-hairline--surround" @click="onFilterWorkTimes" v-if="pickStatus === 0">
              <p>{{checkWorkTime}}<img class="filter-arrow" src="../../assets/images/post/bottom_arrow.png" /></p>
            </div>
            <div class="select-box fl van-hairline--surround" @click="onFilterSex" v-if="pickStatus === 1">
              <p>{{checkTipSex}}<img class="filter-arrow" src="../../assets/images/post/bottom_arrow.png" /></p>
            </div>
            <div class="select-box fl van-hairline--surround" @click="onFilterCommission">
              <p>{{checkCommission}}<img class="filter-arrow" src="../../assets/images/post/bottom_arrow.png" /></p>
            </div>
            <div class="select-box select-box-l fl van-hairline--surround" @click="onFilterInterviewTimes">
              <p>{{checkInterviewTime}}<img class="filter-arrow" src="../../assets/images/post/bottom_arrow.png" /></p>
            </div>
          </div>
          <div class="select-filter fr" @click="onFilter">
            <img class="filter-icon lb-vm" src="../../assets/images/post/filter.png" />
            <span class="lb-vm">筛选</span>
          </div>
        </section>
  </div>
</template>
<script>
export default {
  name: 'home-filter',
  components: {},
  data() {
    return {};
  },
  props: {
    prop: {
      type: Object,
      default() {
        return {};
      }
    },
    checkTipPosition: {
      type: String,
      default() {
        return '岗位';
      }
    },
    checkWorkTime: {
      type: String,
      default() {
        return '班次';
      }
    },
    checkTipSex: {
      type: String,
      default() {
        return '性别';
      }
    },
    checkCommission: {
      type: String,
      default() {
        return '佣金';
      }
    },
    checkInterviewTime: {
      type: String,
      default() {
        return '面试时间';
      }
    },
    pickStatus: Number
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {
    onFilterStation() {
      this.$emit('onFilterStation');
    },
    onFilterWorkTimes() {
      this.$emit('onFilterWorkTimes');
    },
    onFilterSex() {
      this.$emit('onFilterSex');
    },
    onFilterCommission() {
      this.$emit('onFilterCommission');
    },
    onFilterInterviewTimes() {
      this.$emit('onFilterInterviewTimes');
    },
    onFilter() {
      this.$emit('onFilter');
    }
  }
};
</script>
<style lang="less" scoped>
  .select-filter {
    flex: 0 0 auto;
    margin: 10px 0px 10px 4px;
    padding: 0 10px;
    height: 25px;
    line-height: 23px;
    background: #fff;
    border-radius: 16px;
    border: 1px solid #E5E7EB;
    font-weight: 500;
    font-size: 12px;
    color: #4A4A5A;
    display: inline-block;
    box-sizing: border-box;
  }
  .filter-icon {
    width: 12px;
    height: 12px;
    margin-right: 6px;
    vertical-align: middle;
  }
  .clearfix {
    display: flex;
    align-items: center;
  }
  .select-div{
    display: flex;
    flex: 1;
    min-width: 0;
    overflow-x: auto;
    flex-wrap: nowrap;
    -webkit-overflow-scrolling: touch;
  }
  .select-div::-webkit-scrollbar {
    display: none;
  }
  .select-box{
    box-sizing:border-box;
    flex: 0 0 auto;
    background:#fff;
    height:25px;
    border-radius:16px;
    padding:0 8px;
    margin:10px 4px 10px 0;
    position:relative;
    border: 1px solid #ececf0;
    font-weight: 500;
    font-size: 12px;
    color: #4A4A5A;
    display: flex;
    align-items: center;
  }
  .select-box-l{padding:0 8px;}
  .select-box.van-hairline--surround::after {
    display: none;
  }
  .select-box p{
    font-size:12px;
    line-height:1;
    margin:0;
    font-weight: 500;
    color: #4A4A5A;
    display: flex;
    align-items: center;
    white-space: nowrap;
  }
  .filter-arrow {
    width: 12px;
    height: 12px;
    margin-left: 4px;
  }
</style>
